/**
 * Set the SVG Loading animation
 */
export const setLoadingState = (element, isLoading = true) => {
  isLoading
    ? element.classList.add(`is-loading`)
    : element.classList.remove(`is-loading`)
}
